"use strict";

require("core-js/modules/es6.number.constructor");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStatePovertyLevel;
/* eslint-disable no-lonely-if,brace-style */

function getStatePovertyLevel(dirtyState, persons) {
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'monthly';
  if (dirtyState == null) throw new Error('Missing State');
  if (persons == null) throw new Error('Missing Persons Count');
  var state = dirtyState.toUpperCase(); // https://aspe.hhs.gov/poverty-guidelines

  var cutoff = null;

  if (state === 'AK') {
    if (persons === 1) {
      cutoff = 15600;
    } else if (persons === 2) {
      cutoff = 21130;
    } else if (persons === 3) {
      cutoff = 26660;
    } else if (persons === 4) {
      cutoff = 32190;
    } else if (persons === 5) {
      cutoff = 37720;
    } else if (persons === 6) {
      cutoff = 43250;
    } else if (persons === 7) {
      cutoff = 48780;
    } else if (persons === 8) {
      cutoff = 54310;
    } else {
      cutoff = 54310 + 5530 * (persons - 8);
    }
  } else if (state === 'HI') {
    if (persons === 1) {
      cutoff = 14380;
    } else if (persons === 2) {
      cutoff = 19460;
    } else if (persons === 3) {
      cutoff = 24540;
    } else if (persons === 4) {
      cutoff = 29620;
    } else if (persons === 5) {
      cutoff = 34700;
    } else if (persons === 6) {
      cutoff = 39780;
    } else if (persons === 7) {
      cutoff = 44860;
    } else if (persons === 8) {
      cutoff = 49940;
    } else {
      cutoff = 48750 + 4970 * (persons - 8);
    }
  } else {
    if (persons === 1) {
      cutoff = 12490;
    } else if (persons === 2) {
      cutoff = 16910;
    } else if (persons === 3) {
      cutoff = 21330;
    } else if (persons === 4) {
      cutoff = 25750;
    } else if (persons === 5) {
      cutoff = 30170;
    } else if (persons === 6) {
      cutoff = 34590;
    } else if (persons === 7) {
      cutoff = 39010;
    } else if (persons === 8) {
      cutoff = 43430;
    } else {
      cutoff = 43430 + 4420 * (persons - 8);
    }
  }

  return period === 'monthly' ? Number(Number(cutoff * multiplier / 12).toFixed(2)) : Number(cutoff * multiplier).toFixed(2);
}